import { I18n } from '@calendly/i18n'

import { BaseNotificationSection } from '../base_notification_section'

export const EmailRemindersSection = ({ eventType }) => (
  <BaseNotificationSection
    kind="invitee_reminder"
    eventType={eventType}
    description={I18n.t('publisher.event_type_editor.sections.communications.email_reminders.description')}
  />
)
